import { messages } from "../helpers/messages";

export const loginFormValidations = (
  fieldValues,
  temp,
  values,
  setValues,
  setErrors
) => {
  if ("username" in fieldValues) {
    temp.username = fieldValues.username ? "" : messages.errors.user_req;
  }
  if ("password" in fieldValues) {
    temp.password = fieldValues.password ? "" : messages.errors.pass_req;
  }

  setErrors({
    ...temp,
  });
  if (fieldValues === values) return Object.values(temp).every((x) => x === "");
};

export const creationValidations = (
  fieldValues,
  temp,
  values,
  setValues,
  setErrors
) => {
  if ("restaurant_group" in fieldValues) {
    temp.restaurant_group = fieldValues.restaurant_group
      ? ""
      : "Please select restaurant group!";
  }
  if ("branch" in fieldValues) {
    temp.branch = fieldValues.branch ? "" : "Please enter branch!";
  }
  if ("city" in fieldValues) {
    temp.city = fieldValues.city ? "" : "Please select city!";
  }
  if ("username" in fieldValues) {
    temp.username = fieldValues.username ? "" : "Please enter username!";
  }
  if ("password" in fieldValues) {
    temp.password = fieldValues.password ? "" : "Please enter password!";
  }
  if ("address" in fieldValues) {
    temp.address = fieldValues.address ? "" : "Please enter address!";
  }

  setErrors({
    ...temp,
  });
  if (fieldValues === values) return Object.values(temp).every((x) => x === "");
};
